import { ReactNode } from 'react';
import Header from './Header';

interface Props {
  children: ReactNode;
  flowName: string;
  clinicName?: string;
}

function Layout({ children, flowName, clinicName }: Props) {
  return (
    <div className="w-4/5 mx-auto max-w-[860px]">
      <Header flowName={flowName} clinicName={clinicName} />
      {children}
    </div>
  );
}

export default Layout;
